// extracted by mini-css-extract-plugin
export default {"wrapper":"ImagePreviewSpace_wrapper__zFT6z","image":"ImagePreviewSpace_image__lidUy"};